"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.PureSubscriptionPopup = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _reactI18next = require("react-i18next");
var _api = require("../../api");
var _Button = _interopRequireDefault(require("../Button"));
var _InnerPopupWrapper = _interopRequireDefault(require("../InnerPopupWrapper"));
var _Loader = _interopRequireDefault(require("../Loader"));
var _checkmarkBase = _interopRequireDefault(require("../../assets/images/checkmarkBase"));
var _planHelper = require("../../util/planHelper");
var _eventDispatcher = _interopRequireWildcard(require("../../util/eventDispatcher"));
var _planDetailsSlice = require("../../redux/planDetailsSlice");
var _popupSlice = require("../../redux/popupSlice");
var _InnerPopupWrapperStyled = require("../InnerPopupWrapper/InnerPopupWrapperStyled");
var _SkeletonWrapper = _interopRequireDefault(require("../SkeletonWrapper"));
var _innerPopupReducer = require("../../redux/innerPopupReducer");
var _PauseSubscriptionPopupStyled = require("./PauseSubscriptionPopupStyled");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var Close = function Close(props) {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
    ...props,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("defs", {
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("style", {
        children: [".a", "{", "fill:#cb4477", "}"]
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      className: "a",
      d: "M83.448 13.624V0H0v80.042h11.921v11.921h81.745V13.624ZM3.406 76.636V3.406h76.636v10.218H11.921v63.012ZM90.26 88.557H15.327V17.03H90.26Z"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      className: "a",
      d: "M67.244 38.343a1.7 1.7 0 0 0-2.408 0L52.793 50.385 40.751 38.343a1.703 1.703 0 0 0-2.408 2.408l12.042 12.042-12.042 12.042a1.703 1.703 0 1 0 2.408 2.408l12.042-12.042 12.042 12.043a1.703 1.703 0 0 0 2.408-2.408L55.201 52.793l12.043-12.042a1.7 1.7 0 0 0 0-2.408Z"
    })]
  });
};
Close.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "93.667",
  height: "91.963"
};
const PauseSubscriptionPopup = () => {
  const STEPS = {
    PAUSE_DETAILS: 'PAUSE_DETAILS',
    CONFIRMATION: 'CONFIRMATION'
  };
  const STEPS_NUMBERS = {
    PAUSE_DETAILS: 1,
    CONFIRMATION: 2
  };
  const [step, setStep] = (0, _react.useState)(STEPS.PAUSE_DETAILS);
  const [isLoading, setIsLoading] = (0, _react.useState)(false);
  const [isError, setError] = (0, _react.useState)(false);
  const {
    offerToSwitch: fromOffer
  } = (0, _reactRedux.useSelector)(state => state.plan);
  const {
    isLoading: isPopupLoading,
    pauseSubscription: {
      offerData: toOffer
    }
  } = (0, _reactRedux.useSelector)(state => state.popupManager);
  const dispatch = (0, _reactRedux.useDispatch)();
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  const pauseSubscription = async () => {
    setIsLoading(true);
    try {
      const resp = await (0, _api.subscriptionSwitch)(fromOffer.offerId, toOffer.toOfferId, toOffer.switchDirection);
      if (!resp.errors.length) {
        (0, _eventDispatcher.default)(_eventDispatcher.MSSDK_SWITCH_POPUP_ACTION_SUCCESSFUL, {
          fromOfferId: fromOffer.offerId,
          toOfferId: toOffer.toOfferId,
          switchDirection: toOffer.switchDirection,
          algorithm: toOffer.algorithm,
          subscriptionSwitchId: resp.responseData.id,
          subscriptionId: fromOffer.subscriptionId
        });
        setIsLoading(false);
        setStep(STEPS.CONFIRMATION);
      } else {
        (0, _eventDispatcher.default)(_eventDispatcher.MSSDK_SWITCH_POPUP_ACTION_FAILED, {
          reason: resp.errors[0]
        });
        setError(true);
        setIsLoading(false);
      }
    } catch {
      (0, _eventDispatcher.default)(_eventDispatcher.MSSDK_SWITCH_POPUP_ACTION_FAILED);
      setError(true);
      setIsLoading(false);
    }
  };
  const closePopupAndRefresh = () => {
    dispatch((0, _popupSlice.hidePopup)());
    dispatch((0, _planDetailsSlice.updateList)());
  };
  if (isPopupLoading) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_InnerPopupWrapper.default, {
      steps: 2,
      popupTitle: t('pausesubscription-popup.pausing-plan', 'Pausing plan'),
      currentStep: 1,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_SkeletonWrapper.default, {
        showChildren: false,
        height: 200,
        width: 450,
        margin: "auto"
      })
    });
  }
  if (isError) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_InnerPopupWrapper.default, {
      steps: 3,
      popupTitle: t('pausesubscription-popup.pausing-plan', 'Pausing plan'),
      currentStep: STEPS_NUMBERS[step] + 1,
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_InnerPopupWrapperStyled.ContentStyled, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_PauseSubscriptionPopupStyled.ImageWrapper, {
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(Close, {})
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_InnerPopupWrapperStyled.TitleStyled, {
            $step: step,
            children: t('pausesubscription-popup.error-title', 'An error occurred.')
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_InnerPopupWrapperStyled.TextStyled, {
            step: step,
            children: t('pausesubscription-popup.error-description', 'We have been unable to pause your plan as an error occurred. Sorry for the inconvenience, please try again.')
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_InnerPopupWrapperStyled.ButtonWrapperStyled, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
            theme: "confirm",
            onClickFn: closePopupAndRefresh,
            children: t('pausesubscription-popup.back-button', 'Back to My Account')
          })
        })]
      })
    });
  }
  const pauseStartingDate = (0, _planHelper.dateFormat)(fromOffer.expiresAt);
  const {
    offerTitle
  } = fromOffer;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_InnerPopupWrapper.default, {
    steps: 3,
    popupTitle: t('pausesubscription-popup.pausing-plan', 'Pausing plan'),
    currentStep: STEPS_NUMBERS[step] + 1,
    children: [step === STEPS.PAUSE_DETAILS && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_InnerPopupWrapperStyled.ContentStyled, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_PauseSubscriptionPopupStyled.ImageWrapper, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_PauseSubscriptionPopupStyled.SubscriptionIconStyled, {
            period: fromOffer.period,
            showLabel: "Current",
            gray: true
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_PauseSubscriptionPopupStyled.ArrowStyled, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_PauseSubscriptionPopupStyled.SubscriptionIconStyled, {
            isPaused: true,
            showLabel: "Paused"
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_InnerPopupWrapperStyled.TitleStyled, {
          $step: step,
          $textTransform: "capitalize",
          children: t('pausesubscription-popup.details.title', 'Subscription pause')
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_InnerPopupWrapperStyled.TextStyled, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactI18next.Trans, {
            i18nKey: "pausesubscription-popup.details.info",
            children: ["On your next billing cycle (", /*#__PURE__*/(0, _jsxRuntime.jsx)("strong", {
              children: {
                pauseStartingDate
              }
            }), ") your subscription pause will go into effect. While your subscription is paused, you won\u2019t be charged for, and you won\u2019t have access to,", ' ', {
              offerTitle
            }, ". You can resume your ", {
              offerTitle
            }, ' ', "subscription at any time."]
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_InnerPopupWrapperStyled.TextStyled, {
          children: t('pausesubscription-popup.details.note', 'Or, if you don`t do anything, your subscription will automatically resume at the start of the next season. When your subscription resumes, you will be billed the current monthly subscription fee for your plan.')
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_InnerPopupWrapperStyled.TextStyled, {
          step: step,
          children: t('pausesubscription-popup.details.question', 'Would you like to pause?')
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_InnerPopupWrapperStyled.ButtonWrapperStyled, {
        $removeMargin: true,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
          theme: "simple",
          onClickFn: () => {
            dispatch((0, _popupSlice.showPopup)({
              type: _innerPopupReducer.POPUP_TYPES.updateSubscription,
              data: {
                action: 'unsubscribe',
                offerData: {
                  ...fromOffer
                }
              }
            }));
          },
          children: t('pausesubscription-popup.details.back', 'Back')
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
          theme: "confirm",
          onClickFn: pauseSubscription,
          children: isLoading ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Loader.default, {
            buttonLoader: true,
            color: "#ffffff"
          }) : t('pausesubscription-popup.confirm-button', 'Pause subscription')
        })]
      })]
    }), step === STEPS.CONFIRMATION && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_InnerPopupWrapperStyled.ContentStyled, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_PauseSubscriptionPopupStyled.ImageWrapper, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_PauseSubscriptionPopupStyled.ImageStyled, {
            src: _checkmarkBase.default,
            alt: "checkmark icon"
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_InnerPopupWrapperStyled.TitleStyled, {
          $step: step,
          children: t('pausesubscription-popup.confirmation.title', 'Your pause request has been confirmed.')
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_InnerPopupWrapperStyled.TextStyled, {
          $step: step,
          children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactI18next.Trans, {
            i18nKey: "pausesubscription-popup.confirmation.info",
            children: ["You will continue to have access to your subscription through your current billing cycle. The pause will go into effect on", ' ', /*#__PURE__*/(0, _jsxRuntime.jsx)("strong", {
              children: {
                pauseStartingDate
              }
            })]
          })
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_InnerPopupWrapperStyled.ButtonWrapperStyled, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
          theme: "confirm",
          onClickFn: closePopupAndRefresh,
          children: t('pausesubscription-popup.resign-button', 'Back to My Account')
        })
      })]
    })]
  });
};
exports.PureSubscriptionPopup = PauseSubscriptionPopup;
var _default = exports.default = PauseSubscriptionPopup;